<template>
    <button
        class="
          group relative flex flex-col items-center font-medium text-gray-darker outline-none

          disabled:opacity-40

          focus:outline-none
        "
        :label="label"
        :disabled="disabled"
    >
        <button-has-text-badge v-if="showTextBadge" />
        <div :class="[
            `
              relative mb-2 flex w-full items-center justify-center overflow-hidden bg-gray-200 outline-none transition-all duration-300

              focus:outline-none

              group-focus-visible:outline group-focus-visible:outline-2 group-focus-visible:outline-offset-2 group-focus-visible:outline-black

              ${isSquare ? 'aspect-square min-h-[80px] min-w-[80px]' : ''}
            `,
            isActive ? {
                'rounded-[4px] bg-olive text-white': selectedStyle === 'highlight',
                'rounded-[12px] border-2 border-gray-darker': selectedStyle === 'outline',
            } : {
                'rounded-[4px] text-gray-darker': selectedStyle === 'highlight',
                'rounded-[4px] border-2 border-gray-200 text-gray-darker': selectedStyle === 'outline',
            }
        ]" :style="{
            width: sizeInPx ? `${sizeInPx}px` : '',
            height: sizeInPx ? `${sizeInPx}px` : '',
            padding: sizeInPx ? '0' : '16px 24px',
        }">
            <slot />
        </div>
        <div v-if="button?.label"
            class="
              hidden font-caption

              lg:block
            " v-html="button.label"
            :aria-hidden="true"
        />
    </button>
</template>

<script>
    import ButtonHasTextBadge from '../badges/HasTextBadge.vue';

    export default {
        name: 'PrimaryButton',

        components: {
            ButtonHasTextBadge,
        },

        props: {
            button: {
                type: Object,
                required: false,
            },
            label: String,
            isActive: {
                type: Boolean,
                default: false,
            },
            innerClass: {
                type: String,
                required: false,
            },
            sizeInPx: {
                type: Number,
                required: false,
            },
            selectedStyle: {
                type: String,
                default: 'highlight',
                validator(value) {
                    return ['highlight', 'outline'].includes(value);
                },
            },
            isSquare: {
                type: Boolean,
                default: false,
            },
            showTextBadge: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
